import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Timeline from '../components/Timeline';
import { getTrackingHistory } from '../services/trackingService';
import '../styles/JourneyPage.css';

const JourneyPage = () => {
  const { trackingNumber: encodedTracking } = useParams();
  const [trackingHistory, setTrackingHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [actualTrackingNumber, setActualTrackingNumber] = useState('');
  const [attachment, setAttachment] = useState(null);

  useEffect(() => {
    const fetchTrackingData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const trackingNumber = atob(encodedTracking);
        setActualTrackingNumber(trackingNumber);
        const data = await getTrackingHistory(trackingNumber);
        
        // Handle redirect response (when searched by attachment)
        if (data.redirect && data.trackingNumber) {
          const newEncodedTracking = btoa(data.trackingNumber);
          console.log('Redirecting to:', data.trackingNumber);
          window.location.href = `/status/${newEncodedTracking}`;
          return;
        }
        
        // Handle both array response and object response
        if (Array.isArray(data)) {
          setTrackingHistory(data);
        } else {
          setTrackingHistory(data.history || data);
          // Set attachment if it exists and is not empty
          if (data.attachment && data.attachment.trim() !== '') {
            const attArr = data.attachment.split('/').map(att => att.trim());
            setAttachment(attArr);
          }
        }
      } catch (err) {
        setError(err.message || 'Failed to fetch tracking information');
      } finally {
        setLoading(false);
      }
    };

    if (encodedTracking) {
      fetchTrackingData();
    }
  }, [encodedTracking]);

  if (loading) {
    return (
      <div className="journey-page">
        <div className="container">
          <div className="journey-header">
            <Link to="/" className="back-link">← Back to Search</Link>
            <h1>Tracking: {actualTrackingNumber}</h1>
          </div>
          <div className="loading">
            <div className="spinner"></div>
            <p>Loading tracking information...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="journey-page">
        <div className="container">
          <div className="journey-header">
            <Link to="/" className="back-link">← Back to Search</Link>
            <h1>Tracking: {actualTrackingNumber}</h1>
          </div>
          <div className="error" style={{ backgroundColor: '#f5f5f5', color: '#666', border: '1px solid #ddd' }}>
            <h3>Tracking Information Not Found</h3>
            <p>{error}</p>
            <p>Please check your tracking number and try again.</p>
            <Link to="/" className="btn btn-primary" style={{ marginTop: '16px' }}>
              Try Another Tracking Number
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="journey-page">
      <div className="container">
        <div className="journey-header">
          <Link to="/" className="back-link">← Back to Search</Link>
          <h1>Tracking: {actualTrackingNumber}</h1>
          {attachment && (
            <div className="attachment-text">Attachment{attachment.length > 1 ? 's' : ''}:  
              <div className='attachment-container'>
                  {attachment.map((att, index) => (
                    <div className='attachment-contents'key={index}>{att}</div>
                  ))}
              </div>
            </div>
          )}
          <div className="journey-summary">
            <span className="status-badge">
              {trackingHistory[trackingHistory.length - 1]?.status || 'Unknown'}
            </span>
            <span className="update-count">
              {trackingHistory.length} update{trackingHistory.length !== 1 ? 's' : ''}
            </span>
          </div>
        </div>
        
        <div className="journey-content">
          <Timeline trackingHistory={trackingHistory} />
        </div>
      </div>
    </div>
  );
};

export default JourneyPage;